import ErrorToasts from './ErrorToasts';

export default ErrorToasts;
